import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { ISearchParam } from '../BaseApp'
import { handleRequestError } from '../../services/api'
import { updateQuickNotification, updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { IAxiosDefaultDataObject } from '../../config'
import { IDataDisplayerHeaderOptionActionButton, IDataDisplayerPagination, IDataDisplyerItemActionOption } from '../../components/DataDisplayer/DataDisplayer'
import AdminDynamicBasePage from '../admin/AdminDynamicBasePage'
import { addNewItem, deleteItem, updateAllItems, updateItemsLoadingStatus, updateItemsPagination, updateItemsSearch, useReturnAllItems, useReturnItemsLoadingStatus, useReturnItemsPagination, useReturnItemsSearch } from './itemsSlice'
import { addNewSection, useReturnAllSections, useReturnSectionsPagination } from '../sections/sectionsSlice'
import ItemsApp, { IItemModel } from './ItemsApp'
import DynamicForm, { IDynamicForm, IDynamicFormElement } from '../../components/Form/DynamicForm'
import windowLocationRedirect from '../redirect'
import { addNewWarehouse, useReturnAllWarehouses } from '../warehouses/warehousesSlice'
import WarehousesApp from '../warehouses/WarehousesApp'
import SectionsApp from '../sections/SectionsApp'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { addNewUser, useReturnAllUsers, useReturnCurrentUser } from '../user/userSlice'
import UsersApp from '../user/UsersApp'
import { addNewBrand, useReturnAllBrands } from '../brands/brandsSlice'
import BrandsApp from '../brands/BrandsApp'
import ExportItems from './ExportItems'
import PrintSelectedItems from './PrintSelectedItems'
import { Button } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import TransactionsOrder from '../transactions/TransactionsOrder'
import ContainerItemsModal from './ContainerItemsModal'
import isEqual from 'lodash/isEqual';
import ItemsList from './ItemsList'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import PageHeadSection from '../admin/components/PageHeadSection'

interface IProps {
    isInventoryPage?: boolean,
    customWarehouseId?: number,
    dashboardPage?: boolean,
    customDataDisplayerActionButtons?: IDataDisplayerHeaderOptionActionButton[],
    customDisplayerName?: string,
    localItems?: boolean,
    disableSectionBoxContainer?: boolean,
}

interface ILoadItemsRequest {
    page: number, 
    search: string|null, 
    disablePagination: boolean, 
    addItems?: boolean, 
    searchParams?: Array<ISearchParam>
}

export default function ItemsBasePage(props: IProps){

    const { isInventoryPage, customWarehouseId, dashboardPage, customDataDisplayerActionButtons, customDisplayerName, localItems, disableSectionBoxContainer } = props

    const renderItems = () => {
        return(
            <ItemsList 
                isInventoryPage={isInventoryPage}
                customWarehouseId={customWarehouseId} 
                // updateSearchParamsBeforeLoadItems={(params) => {
                    
                //     if (customWarehouseId){
                //         return [
                //             ...params,
                //             {
                //                 name: "warehouse_id",
                //                 value: customWarehouseId
                //             }
                //         ]
                //     }

                //     return params

                // }}
                disableRemoveEmptySearchParams={true}
                updateSearchParamsBeforeLoadItems={(params) => {
                    
                    let searhParamsList = [...params]

                    if (searhParamsList){
                        searhParamsList = searhParamsList.filter(
                            (param) => param.value !== null && param.value !== 0 && param.value !== false
                        )
                    }

                    if (customWarehouseId){
                        searhParamsList = [
                            ...searhParamsList,
                            {
                                name: "warehouse_id",
                                value: customWarehouseId
                            }
                        ]
                    }

                    return searhParamsList

                }}
            />
        )
    }

    return(
        <div>

            {!dashboardPage && !isInventoryPage && <PageHeadSection pageName={"items"} />}

            {!disableSectionBoxContainer ? <SectionBoxContainer>{renderItems()}</SectionBoxContainer> : renderItems()}
        </div>
    )
}

// export default function ItemsBasePage(props: IProps) {

//     const { isInventoryPage, customWarehouseId, dashboardPage, customDataDisplayerActionButtons, customDisplayerName, localItems } = props

//     const dispatch = useDispatch()
//     const navigate = useNavigate()
//     const location = useLocation()

//     const [showQrCodeScanner, setShowQrCodeScanner] = useState<boolean>(false)
//     const [showItemsPrintPage, setShowItemsPrintPage] = useState<boolean>(false)

//     const [savedRequest, setSavedRequest] = useState<ILoadItemsRequest>()


//     const returnAllItems = useReturnAllItems()
//     const items = returnAllItems

//     const returnPagination = useReturnItemsPagination()
//     const returnLoading = useReturnItemsLoadingStatus()
//     const returnSearch = useReturnItemsSearch()


//     const pagination = returnPagination
//     const loading = useReturnItemsLoadingStatus()
//     const search = returnSearch

//     const currentUser = useReturnCurrentUser()

//     const filterFormElementsSuperUser: IDynamicFormElement[] = customWarehouseId ? [
//         {
//             id: "status",
//             xs: 4,
//             type: "Select",
//             label: "Status",
//             fullWidth: true,
//             addNoneItem: true,
//             items: new ItemsApp().itemStatusList
//         },
//         {
//             id: "section_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "Section",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllSections,
//             modelTitleParam: "title",
//             appClass: new SectionsApp(),
//             addNewItem: addNewSection,
//             searchParams: [
//                 {
//                     name: "warehouse_id",
//                     value: customWarehouseId
//                 }
//             ]
//         },
//         {
//             id: "user_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "With User",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllUsers,
//             modelTitleParam: "full_name",
//             appClass: new UsersApp(),
//             addNewItem: addNewUser,
//         },
//         {
//             id: "category_id",
//             xs: 6,
//             type: "SelectCategory",
//             label: "Category",
//             fullWidth: true,
//             displayForItem: true,
//             addNoneItem: true,
//         },
//         {
//             id: "brand_id",
//             xs: 6,
//             type: "DynamicSelect",
//             label: "Brand",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllBrands,
//             modelTitleParam: "title",
//             appClass: new BrandsApp(),
//             addNewItem: addNewBrand,
//         },
//     ] :[
//         {
//             id: "status",
//             xs: 4,
//             type: "Select",
//             label: "Status",
//             fullWidth: true,
//             addNoneItem: true,
//             items: new ItemsApp().itemStatusList
//         },
//         {
//             id: "warehouse_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "Waerehouse",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllWarehouses,
//             modelTitleParam: "title",
//             appClass: new WarehousesApp(),
//             addNewItem: addNewWarehouse,
//         },
//         {
//             id: "section_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "Section",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllSections,
//             modelTitleParam: "title",
//             appClass: new SectionsApp(),
//             addNewItem: addNewSection,
//             filterBy: "warehouse_id"
//             // searchParams: [
//             //     {
//             //         name: "warehouse_id",
//             //         value: selectedWarehouseId
//             //     }
//             // ]
//         },
//         {
//             id: "category_id",
//             xs: 4,
//             type: "SelectCategory",
//             label: "Category",
//             fullWidth: true,
//             displayForItem: true,
//             addNoneItem: true,
//         },
//         {
//             id: "brand_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "Brand",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllBrands,
//             modelTitleParam: "title",
//             appClass: new BrandsApp(),
//             addNewItem: addNewBrand,
//         },
//         {
//             id: "user_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "With User",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllUsers,
//             modelTitleParam: "full_name",
//             appClass: new UsersApp(),
//             addNewItem: addNewUser,
//         },
//     ]

//     const filterFormElementsStaff: IDynamicFormElement[] = customWarehouseId ? [
//         {
//             id: "status",
//             xs: 4,
//             type: "Select",
//             label: "Status",
//             fullWidth: true,
//             addNoneItem: true,
//             items: new ItemsApp().itemStatusList
//         },
//         {
//             id: "section_id",
//             xs: 4,
//             type: "DynamicSelect",
//             label: "Section",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllSections,
//             modelTitleParam: "title",
//             appClass: new SectionsApp(),
//             addNewItem: addNewSection,
//             searchParams: [
//                 {
//                     name: "warehouse_id",
//                     value: customWarehouseId
//                 }
//             ]
//         },
//         {
//             id: "category_id",
//             xs: 4,
//             type: "SelectCategory",
//             label: "Category",
//             fullWidth: true,
//             displayForItem: true,
//             addNoneItem: true,
//         },
//     ] :[
//         {
//             id: "status",
//             xs: 3,
//             type: "Select",
//             label: "Status",
//             fullWidth: true,
//             addNoneItem: true,
//             items: new ItemsApp().itemStatusList
//         },
//         {
//             id: "warehouse_id",
//             xs: 3,
//             type: "DynamicSelect",
//             label: "Waerehouse",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllWarehouses,
//             modelTitleParam: "title",
//             appClass: new WarehousesApp(),
//             addNewItem: addNewWarehouse,
//         },
//         {
//             id: "section_id",
//             xs: 3,
//             type: "DynamicSelect",
//             label: "Section",
//             fullWidth: true,
//             addNoneItem: true,
//             itemsList: useReturnAllSections,
//             modelTitleParam: "title",
//             appClass: new SectionsApp(),
//             addNewItem: addNewSection,
//             filterBy: "warehouse_id"
//             // searchParams: [
//             //     {
//             //         name: "warehouse_id",
//             //         value: selectedWarehouseId
//             //     }
//             // ]
//         },
//         {
//             id: "category_id",
//             xs: 3,
//             type: "SelectCategory",
//             label: "Category",
//             fullWidth: true,
//             displayForItem: true,
//             addNoneItem: true,
//         },
//     ]


//     const itemsApp = new ItemsApp()

//     /**
//      * Update loading status
//      */
//     const updateLoadingStatus = (status: boolean) => dispatch(updateItemsLoadingStatus({ loading: status }))

//     /**
//      * Load items
//      */
//     const loadItems = (page: number, search: string|null, disablePagination: boolean, addItems?: boolean, searchParams?: Array<ISearchParam>) => {
//         updateLoadingStatus(true)

//         let searchParamsList: ISearchParam[] = []

//         if (searchParams){
//             searchParamsList = [
//                 ...searchParams
//             ]
//         }

//         if (customWarehouseId){
//             searchParamsList = [
//                 ...searchParamsList,
//                 {
//                     name: "warehouse_id",
//                     value: customWarehouseId
//                 }
//             ]
//         }

//         let request: ILoadItemsRequest = {
//             page: page,
//             search: search,
//             disablePagination: disablePagination,
//             addItems: addItems,
//             searchParams: searchParams
//         }

//         console.log("request: ", request, "savedRequest:", savedRequest)

//         if (!isEqual(request, savedRequest)){
//             itemsApp.listOfInstances(page, search, disablePagination, addItems, searchParamsList)
//                 .then(response => {

//                     const { data } = response
//                     const results: Array<IItemModel> = disablePagination ? data : data.results

//                     console.log("response", response)

//                     if (addItems){
//                         results.map((singleItem) => dispatch(addNewItem(singleItem)))
//                     }else{
//                         dispatch(updateAllItems([]))
//                         dispatch(updateAllItems(results))
//                     }
                    
//                     if (!disablePagination){
//                         dispatch(updateItemsPagination({
//                             count: data.count,
//                             current_page: page,
//                             total_pages: data.total_pages
//                         }))
//                     }else{
//                         dispatch(updateItemsPagination({
//                             count: results.length,
//                             current_page: 1,
//                             total_pages: 1
//                         }))
//                     }

//                     updateLoadingStatus(false)

//                     setSavedRequest(request)
//                     console.log(" setSavedRequest(request)")
//                     console.log(request)

//                 })
//                 .catch(error => {

//                     handleRequestError(error, dispatch)
//                     updateLoadingStatus(false)


//                 })
//         }else{
//             console.log("Request is the same", request, savedRequest)
//         }
//     }

//     /**
//      * Delete item
//      */
//     const handleDeleteItem = (id: number) => {

//         updateLoadingStatus(true)

//         itemsApp.deleteInstance(id)
//             .then(response => {
//                 updateLoadingStatus(false)

//                 dispatch(deleteItem({ id: id }))
//                 dispatch(updateItemsPagination({
//                     ...pagination,
//                     count: pagination.count - 1
//                 }))

//                 updateQuickNotificationDetails(true, "Done!", "success", dispatch)
//             })
//             .catch(error => {
//                 updateLoadingStatus(false)
//                 handleRequestError(error, dispatch)
//             })

//     }

//     /**
//      * Handle delete many items
//      */
//     const handleDeleteManyItems = (records: Array<IAxiosDefaultDataObject>) => {
//         updateLoadingStatus(true)

//         itemsApp.deleteManyInstances(records)
//             .then(response => {
//                 updateLoadingStatus(false)

                
//                 records.map((record) => {
//                     dispatch(deleteItem({ id: record.id }))
//                 })

//                 dispatch(updateItemsPagination({
//                     ...pagination,
//                     count: pagination.count - records.length
//                 }))

//                 updateQuickNotificationDetails(true, "Done!", "success", dispatch)
//             })
//             .catch(error => {
//                 updateLoadingStatus(false)
//                 handleRequestError(error, dispatch)
//             })   
//     }

//     /**
//      * Handle update search
//      */
//     const handleUpdateSearch = (search: string) => {
//         dispatch(updateItemsSearch({ search: search }))
//     }


//     /**
//      * actions
//      */
//     const itemActionOptions: Array<IDataDisplyerItemActionOption> = [
//         {
//             icon: "edit",
//             label: "Edit",
//             onClick: (rawItem) => {
//                 navigate("/panel/items/edit/" + rawItem.id)
//             },
//         },
//         {
//             icon: "show",
//             label: "View",
//             onClick: (rawItem) => {
//                 navigate(isInventoryPage ? "/items/" + rawItem.unique_id :"/panel/items/view/" + rawItem.id)
//             },
//         },
//     ]

//     /**
//      * Filter Form
//      */
//     const [filterForm, setFilterForm] = useState<IDynamicForm>({
//         name: "items-data-displayer-filter-form",
//         elements: currentUser.is_superuser ? filterFormElementsSuperUser : filterFormElementsStaff
//     })

//     /**
//      * Custom Option Button
//      */
//     const customHeaderOptionActionButtons: Array<IDataDisplayerHeaderOptionActionButton> = customDataDisplayerActionButtons ? customDataDisplayerActionButtons : [
//         {
//             icon: "qrcode",
//             label: "Scan",
//             onClick: () => {
//                 setShowQrCodeScanner(showQrCodeScanner ? false : true)
//             }
//         },
//         {
//             icon: "download",
//             label: "Export",
//             onClick: () => {},
//             customContent: (button) => {
//                 return <TransactionsOrder />
//             }
//         },
//         {
//             icon: "download",
//             label: "Export",
//             onClick: () => {},
//             customContent: (button) => {
//                 return <ExportItems showPrintPage={() => setShowItemsPrintPage(true)} />
//             }
//         },
//     ]

//     /**
//      * Handle scanned qr code
//      */
//     const handleScannedQrCode = (result: string) => {
//         if (itemsApp.validateUniqueId(result)){

//             if (items.length > 0){

//                 let link: string = "panel/items/view/" + result
//                 let isFound: boolean = false

//                 items.map((item) => {
//                     if (item.unique_id === result){
//                         link = "panel/items/view/" + item.id
//                         isFound = true
//                     }
//                 })

//                 const inventoryPageLink: string = "items/" + result

//                 if (isInventoryPage || !isFound){
//                     link = inventoryPageLink
//                 }

//                 windowLocationRedirect(link)
//             }

//             dispatch(updateItemsSearch({ search: result }))

//             const submitSearch = document.getElementById(itemsApp.elemPrefix + "displayer_handle-search")

//             console.log(itemsApp.elemPrefix + "displayer_handle-search")

//             if(submitSearch){
//                 console.log("submitSearch", submitSearch)
//                 submitSearch.click()
//             }
//         }else{
//             updateQuickNotificationDetails(true, "Unique ID is incorrect", "error", dispatch)
//         }
//     }

//     /**
//      * Invntory page
//      */
//     useEffect(() => {
//         if (isInventoryPage){
//             console.log("location.pathname load items")
//             loadItems(1, search ? search : "", false)
//         }
//     }, [location.pathname])

//     // useEffect(() => {
//     //     console.log('singleElemDataValue("warehouse_id")', singleElemDataValue("warehouse_id"))
//     // }, [singleElemDataValue("warehouse_id")])

//     useEffect(() => {
//         setFilterForm({
//             name: "items-data-displayer-filter-form",
//             elements: currentUser.is_superuser ? filterFormElementsSuperUser : filterFormElementsStaff
//         })
//     }, [currentUser])

//     return(
//         <>
//             <ScanQRCode shown={showQrCodeScanner} handleDecodedText={handleScannedQrCode} handleClose={() => setShowQrCodeScanner(false)} />
//             <ContainerItemsModal />
//             {showItemsPrintPage ? <PrintSelectedItems goBack={() => setShowItemsPrintPage(false)} /> : 
//                 <AdminDynamicBasePage 
//                     appClass={itemsApp}
//                     itemsList={items}
//                     pagination={pagination}
//                     loading={loading}
//                     search={search}
//                     updateLoadingStatus={updateLoadingStatus}
//                     loadItems={loadItems}
//                     deleteItem={handleDeleteItem}
//                     deleteManyItems={handleDeleteManyItems}
//                     updateSearch={handleUpdateSearch}
//                     itemsActionOptions={itemActionOptions}
//                     filterForm={filterForm}
//                     customHeaderOptionActionButtons={customHeaderOptionActionButtons}
//                     viewItemTemplateLink={isInventoryPage ? "/items/[unique_id]" : "/panel/items/view/[id]"}
//                     hidePageHeadSection={dashboardPage}
//                     customDisplayerName={customDisplayerName}
//                 />
//             }
//         </>
//     )
// }